export const editActions = <const>{
	ND_SKLAD_SELECT_MAPPER: 'ND_SKLAD_SELECT_MAPPER',
};

export const editMutations = <const>{
	ND_SKLAD_SELECT_MAPPER: 'ND_SKLAD_SELECT_MAPPER',
};
